(() => {
  // Only chooses rendering quality. The purchase form and magnetic snap are untouched.
  const selector = 'product-info.pi09-performance';
  const smallScreen = () => window.matchMedia('(max-width:749px)').matches;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function getTier() {
    if (!smallScreen()) return 'full';
    const memory = Number(navigator.deviceMemory || 0);
    const cores = Number(navigator.hardwareConcurrency || 0);
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (reduced() || (memory > 0 && memory <= 3) || (cores > 0 && cores <= 4) || (connection && connection.saveData)) {
      return 'lite';
    }
    return 'balanced';
  }
  function initialize() {
    const quality = getTier();
    document.querySelectorAll(selector).forEach(root => {
      if (root.dataset.pi09Tier !== quality) root.dataset.pi09Tier = quality;
    });
  }
  document.addEventListener('DOMContentLoaded',initialize);
  document.addEventListener('shopify:section:load',initialize);
  window.addEventListener('resize',initialize,{passive:true});
  if(document.readyState !== 'loading') initialize();
})();